import React from 'react';
import './Quote.css';

const Quote = () => (
  <section className="quote">
    <p>
      The Maya were using the concept of zero centuries before it became common in Europe.
      Their mathematical achievements stand among the greatest of the ancient world.
      <hr />
    </p>
    <p>
      Mathematics knows no races or geographic boundaries;
      for mathematics, the cultural world is one country.
      <br />
      <span>— David Hilbert, German mathematician</span>
      <hr />
    </p>
    <p>
      Mathematics is a universal language, but each culture has written its own dialect.
      <br />
      <span>— Anonymous</span>
      <hr />
    </p>
  </section>
);

export default Quote;
